import { makeStyles } from '@material-ui/core/styles'
import { getOutlinedTextFieldWrapperStyles } from 'lib/form-field-styles'

export const useStyles = makeStyles(theme => ({
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  fieldRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(1.5),
    },
  },
  fieldStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  formField: {
    ...getOutlinedTextFieldWrapperStyles(theme),
    margin: 0,
  },
  bodyText: {
    margin: 0,
    marginBottom: theme.spacing(3),
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
  },
  alert: {
    margin: 0,
  },
  confirmationField: {
    margin: 0,
  },
  confirmationLabel: {
    margin: 0,
    alignItems: 'center',
    width: '100%',
  },
  confirmationCheckboxRoot: {
    padding: theme.spacing(0.5),
    color: '#40484C',
    flexShrink: 0,
    '& svg': {
      fontSize: 20,
    },
  },
  confirmationCheckboxChecked: {
    color: '#0053FF',
  },
  confirmationText: {
    margin: 0,
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
  },
  confirmationError: {
    margin: theme.spacing(0.75, 0, 0),
  },
  successContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.spacing(2),
  },
  celebrationIcon: {
    color: theme.palette.primary.main,
    background: 'rgba(0, 117, 202, 0.08)',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  successTitle: {
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: 1.3,
    color: '#172024',
  },
}))
